import React from "react";

import Modal from "../../Modal/Modal";
import {
  Container,
  H2CompensationTitle,
  PCompensationDetail,
} from "./compensationDetailStyle";

export const ConpensationDetail = (props) => {
  const { sidebarInfo, toggleModal } = props;
  return (
    <Modal
      onOutsideClick={() => {
        toggleModal();
      }}
    >
      <React.Fragment>
        <Container>
          <h1>Detalles de compensación</h1>
          <div className="container-labels">
            <div>
              <h2>USUARIO APROBADOR</h2>
              <label htmlFor="test">
                {sidebarInfo.compensationDetail.approved_by}
              </label>
            </div>
            <div>
              <h2>USUARIO COMPENSADOR</h2>
              <label htmlFor="test">
                {sidebarInfo.compensationDetail.compensed_by}
              </label>
            </div>
          </div>
          <div className="container-labels">
            <div>
              <h2>CÓDIGO DE SALDO A FAVOR - MONTO</h2>
              <label htmlFor="test">
                <b style={{ color: "black" }}>
                  {sidebarInfo.compensationDetail.cashback_id}
                </b>
                {" - "}
                {`${
                  sidebarInfo.paymentCurrency === "usd"
                    ? ` $ ${sidebarInfo.compensationDetail.cashback}`
                    : ` S/. ${sidebarInfo.compensationDetail.cashback}`
                }`}
              </label>
            </div>
            <div>
              <h2>CÓDIGO DE COMPENSACIÓN SAP</h2>
              <label htmlFor="test">
                <b style={{ color: "black" }}>
                  {sidebarInfo.compensationDetail.compensation_code}
                </b>
              </label>
            </div>
          </div>
          <div style={{ display: "flex" }}>
            <div>
              <H2CompensationTitle>COMENTARIO APROBADOR</H2CompensationTitle>
              <PCompensationDetail paddingRight="1rem">
                {sidebarInfo.compensationDetail.cashback_comment}
              </PCompensationDetail>
            </div>
            <div>
              <H2CompensationTitle>COMENTARIO COMPENSADOR</H2CompensationTitle>
              <PCompensationDetail paddingRight="1rem">
                {sidebarInfo.compensationDetail.compensation_comment}
              </PCompensationDetail>
            </div>
          </div>
        </Container>
      </React.Fragment>
    </Modal>
  );
};
